/* ============================================================
   BUDDIES NATURAL PET FOOD — THEME JS
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ── NAV SCROLL EFFECT ──
  const nav = document.querySelector('.site-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    });
  }

  // ── MOBILE MENU ──
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
  }

  // ── WHY RAW ACCORDION ──
  document.querySelectorAll('.why-item').forEach(function (item) {
    item.addEventListener('click', function () {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.why-item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
    // Open first by default
  });
  const firstWhy = document.querySelector('.why-item');
  if (firstWhy) firstWhy.classList.add('open');

  // ── FAQ ACCORDION ──
  document.querySelectorAll('.faq-item').forEach(function (item) {
    item.addEventListener('click', function () {
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── FEEDING CALCULATOR ──
  const weightInput = document.getElementById('pet-weight');
  const typeSelect = document.getElementById('pet-type');
  const ageSelect = document.getElementById('pet-age');
  const resultNum = document.getElementById('calc-result-num');
  const resultLabel = document.getElementById('calc-result-label');

  function calcFeeding() {
    if (!weightInput || !resultNum) return;
    const lbs = parseFloat(weightInput.value) || 0;
    if (!lbs) {                                   // nothing picked yet
      if (resultNum) resultNum.textContent = '\u2014';
      if (resultLabel) resultLabel.textContent = "Select your pet's weight above";
      return;
    }
    const weight = lbs * 0.45359237;              // formula below works in kg
    const type = typeSelect ? typeSelect.value : 'dog';
    const age = ageSelect ? ageSelect.value : 'adult';

    let pct = 0.025; // 2.5% default adult dog
    if (age === 'puppy' || age === 'kitten') pct = 0.06;
    else if (age === 'senior') pct = 0.02;
    if (type === 'cat') pct = pct * 0.85;

    const grams = Math.round(weight * 1000 * pct);
    const oz = (grams / 28.35).toFixed(1);

    if (resultNum) resultNum.textContent = oz + ' oz / ' + grams + ' g';
    if (resultLabel) resultLabel.textContent = 'per day';
  }

  if (weightInput) { weightInput.addEventListener('input', calcFeeding); weightInput.addEventListener('change', calcFeeding); }
  if (typeSelect) typeSelect.addEventListener('change', calcFeeding);
  if (ageSelect) ageSelect.addEventListener('change', calcFeeding);
  calcFeeding();

  // ── NEWSLETTER FORM ──
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const input = newsletterForm.querySelector('.newsletter-input');
      const btn = newsletterForm.querySelector('.newsletter-btn');
      if (input && input.value) {
        btn.textContent = '✓';
        input.value = '';
        setTimeout(function () { btn.textContent = '→'; }, 3000);
      }
    });
  }

  // ── HERO PRODUCT STAGE ──
  const heroProds = document.querySelectorAll('.hero-prod');
  if (heroProds.length > 0) {
    let activeIdx = 0;
    function setActive(idx) {
      heroProds.forEach(function (p, i) {
        p.classList.toggle('active', i === idx);
      });
      document.querySelectorAll('.hero-dot').forEach(function (d, i) {
        d.classList.toggle('active', i === idx);
      });
      activeIdx = idx;
    }
    heroProds.forEach(function (prod, idx) {
      prod.addEventListener('click', function () { setActive(idx); });
    });
    document.querySelectorAll('.hero-dot').forEach(function (dot, idx) {
      dot.addEventListener('click', function () { setActive(idx); });
    });
    setActive(0);
    // Auto-rotate
    setInterval(function () {
      setActive((activeIdx + 1) % heroProds.length);
    }, 3500);
  }

});
